import React from 'react'

interface BarChartProps {
  title: string
  data: Array<{
    label: string
    value: number
    color?: string
  }>
  height?: number
}

export const BarChart: React.FC<BarChartProps> = ({
  title,
  data,
  height = 200
}) => {
  const maxValue = Math.max(...data.map(d => d.value))

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="space-y-3" style={{ height: `${height}px` }}>
        {data.map((item, index) => (
          <div key={index} className="flex items-center">
            <div className="w-24 text-sm text-gray-600 truncate">
              {item.label}
            </div>
            <div className="flex-1 ml-3">
              <div className="relative">
                <div
                  className={`h-6 rounded ${
                    item.color || 'bg-purple-600'
                  }`}
                  style={{
                    width: `${maxValue > 0 ? (item.value / maxValue) * 100 : 0}%`
                  }}
                />
                <span className="absolute right-2 top-0 text-xs text-gray-600 leading-6">
                  {item.value}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}